import { Box, Container, VStack } from '@chakra-ui/react';
import React from 'react';

import { About } from './components/About';
import { Contact } from './components/Contact';
import { Features } from './components/Features';
import { Hero } from './components/Hero';
import { MobileShowcase } from './components/MobileShowcase';
import { PracticalExamples } from './components/PracticalExamples';
import { Solutions } from './components/Solutions';

export const PosPage: React.FC = () => {
  return (
    <Box bg="gray.50" minH="100vh">
      <Container maxW="container.xl" py={8}>
        <VStack align="stretch">
          <Hero />
          <About />
          <Features />
          <Solutions />
          <PracticalExamples />
          <MobileShowcase />
        </VStack>
      </Container>
      <Contact />
    </Box>
  );
};

export default PosPage;
